import { type MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { Notification } from '@repo/ui/icons';

import { LoadingKey } from 'utils/promise';

import Flex from 'components/util/Flex';

import { SVerificationButton } from './style';

export type BaseVerificationProps = {
  isVerificationCompleted: boolean;
};

type VerificationButtonProps = {
  isDisabled: boolean; // 버튼 클릭 활성화 여부
  isCompleted: boolean; // 인증 완료 여부
  completedText?: string;
  loadingKey: LoadingKey;
  onClick: MouseEventHandler<HTMLButtonElement>;
};
export default function VerificationButton({
  isDisabled,
  isCompleted,
  onClick,
  loadingKey,
  completedText = 'chat.rewards_creator_information_completed_button',
}: VerificationButtonProps) {
  const { t } = useTranslation();
  return (
    <Flex columnGap={12} align="center">
      {!isCompleted && <Notification color="#FE008A" />}
      <SVerificationButton disabled={isDisabled} onClick={onClick} loadingKey={loadingKey}>
        {t(isCompleted ? completedText : 'chat.rewards_creator_information_verify')}
      </SVerificationButton>
    </Flex>
  );
}
